import axiosInstance from "./axiosInstance";

export const getCourseById = async (courseId) => {
  const res = await axiosInstance.get(`/course/course/${courseId}`,
    { withCredentials: true }
  );
  return res.data;
};

export const getMyCourses = async (userId) => {
  if (!userId) throw new Error("User ID is required");

  const res = await axiosInstance.get("/course/my-courses", {
    params: { userId },
  });
  return res.data.courses;
};

export const getMyLiveClasses = async (userId) => {
  try {
    console.log("Fetching live classes for userId:", userId);
    const res = await axiosInstance.get(
      "liveclass/student",
      {
        params: { userId }, //  userId included
        withCredentials: true,
      }
    );

    return res.data.data;
  } catch (error) {
    console.error(
      "Error fetching live classes:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getFinalAssessment = async (courseId, userId) => {
  const response = await axiosInstance.get(
    `/course/assessmentcourse/${courseId}`,
    {
      params: { userId },
    }
  );
  return response.data;
};